import { render, staticRenderFns } from "./NewFeatureModal.vue?vue&type=template&id=0c45647e&scoped=true"
import script from "./NewFeatureModal.vue?vue&type=script&lang=js"
export * from "./NewFeatureModal.vue?vue&type=script&lang=js"
import style0 from "./NewFeatureModal.vue?vue&type=style&index=0&id=0c45647e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45647e",
  null
  
)

/* custom blocks */
import block0 from "./NewFeatureModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports